export const tapOptions = {
  recognizers: {
    tap: {
      time: 2000,
      threshold: 50, 
    },
  },
};


// WEBPACK FOOTER //
// ./src/utils/hammerOptions.js